import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';

export interface CreateClientCredentialRequest {
  clienteId: number | null;
  razonSocial: string;
  cuit: number | null;
}

export interface UpdateClientCredentialRequest {
  razonSocial: string;
  cuit: number | null;
}

export interface ClientCredential {
  id?: number;
  clienteId?: number;
  razon_social?: string;
  cuit?: number;
  clientId?: string;
  cognitoClientName?: string;
  cognitoClientSecret?: string;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type ClientCredentialFilterValue = string | number | boolean | string[] | number[];

export interface ClientCredentialDataRequest {
  page: number;
  size: number;
  search: string;
  filters: Record<string, ClientCredentialFilterValue>;
}

export interface ClientCredentialPageResponse {
  data: ClientCredential[];
  recordsTotal: number;
  recordsFiltered: number;
}

@Injectable({ providedIn: 'root' })
export class ClientCredentialsApi {
  private readonly baseUrl = '/client/clients';

  constructor(private readonly http: HttpClient) {}

  create(request: CreateClientCredentialRequest): Observable<ClientCredential> {
    return this.http
      .post<ClientCredential>(this.baseUrl, {
        clienteId: Number(request.clienteId),
        razonSocial: request.razonSocial.trim(),
        cuit: Number(request.cuit)
      })
      .pipe(timeout(30000));
  }

  update(clienteId: number, request: UpdateClientCredentialRequest): Observable<ClientCredential> {
    return this.http
      .put<ClientCredential>(`${this.baseUrl}/${clienteId}`, {
        razonSocial: request.razonSocial.trim(),
        cuit: Number(request.cuit)
      })
      .pipe(timeout(30000));
  }

  getData(request: ClientCredentialDataRequest): Observable<ClientCredentialPageResponse> {
    return this.http
      .post<ClientCredentialPageResponse>(`${this.baseUrl}/data`, {
        page: Number(request.page ?? 0),
        size: Number(request.size ?? 10),
        search: request.search ?? '',
        filters: request.filters ?? {}
      })
      .pipe(timeout(30000));
  }

  findByClienteId(clienteId: number): Observable<ClientCredential> {
    return this.http
      .get<ClientCredential>(`${this.baseUrl}/${clienteId}`)
      .pipe(timeout(30000));
  }

  disableByClienteId(clienteId: number): Observable<ClientCredential> {
    return this.http
      .patch<ClientCredential>(`${this.baseUrl}/${clienteId}/disable`, {})
      .pipe(timeout(30000));
  }
}
